
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 151 151","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M80.144 2.47l18.442 18.444h26.083a6 6 0 016 6v26.082l18.444 18.444a6 6 0 010 8.485L130.669 98.37v26.082a6 6 0 01-6 6H98.587l-18.443 18.444a6 6 0 01-8.486 0L53.214 130.45H27.132a6 6 0 01-6-6V98.368L2.689 79.925a6 6 0 010-8.485l18.443-18.443V26.914a6 6 0 016-6h26.083L71.658 2.47a6 6 0 018.486 0z","fill":"#D551AD","fill-rule":"evenodd"}})])
          )
        }
      }
    